import React, { Component } from 'react';
import Slider from 'react-slick';
import CarouselSlide from './CarouselSlide';
import ArrowButton from './ArrowButton';
import AutoAdvancer from './AutoAdvancer';
import SwipeNextPrev from './SwipeNextPrev';

class Carousel extends Component {
  state = {
    animating: false,
    currentIndex: 0,
  };
  slickOptions = {
    dots: false,
    infinite: false,
    draggable: false,
    speed: 1500,
    touchMove: false, //these all
    swipeToSlide: false, // seem
    swipe: false, // the same
    cssEase: 'cubic-bezier(.9, 0, .3, 1)',
    nextArrow: <ArrowButton direction={'right'} white={true} />,
    prevArrow: <ArrowButton direction={'left'} white={true} />,
    beforeChange: (oldIndex, newIndex) => {
      // apparently oldindex doesn't work
      if (this.state.currentIndex !== newIndex) {
        this.setState({ animating: true });
      }
    },
    afterChange: index => {
      this.setState({
        animating: false,
        currentIndex: index,
      });
    },
  };

  render() {
    return (
      <React.Fragment>
        <SwipeNextPrev
          next={this.slider && this.slider.slickNext}
          prev={this.slider && this.slider.slickPrev}
        />
        <Slider
          className="slick slick-full arrow-bottom home-slick"
          ref={el => (this.slider = el)}
          {...this.slickOptions}
        >
          {this.props.slideData.map((slideNode, i) => {
            const slide = slideNode.node;
            return (
              <div key={`slide${i}`}>
                <CarouselSlide
                  color_theme="red"
                  title={slide.home_headline}
                  subtitle={slide.home_body}
                  image={slide.home_image.sizes.large}
                  path={slide.path}
                  buttonCTA={slide.home_cta_text}
                  index={i}
                  waitingForLoad={this.props.introIsShowing}
                  currentIndex={this.state.currentIndex}
                  animating={this.state.animating}
                  revealText={this.props.revealText}
                />
              </div>
            );
          })}
        </Slider>
        {this.slider && (
          <AutoAdvancer
            colorTheme={'red'}
            isTransitioning={this.state.animating}
            nextSlide={this.slider.slickNext}
            anySlide={this.slider.slickGoTo}
            totalSlides={this.props.slideData.length}
            currentIndex={this.state.currentIndex}
            isHome
            exited={this.props.introIsShowing}
            waitingForLoad={this.props.introIsShowing}
          />
        )}
      </React.Fragment>
    );
  }
}

export default Carousel;



// WEBPACK FOOTER //
// ./src/components/ui/Carousel.js